<template>
    <div class="enact-load-error">
        <div class="enact-load-error-card">
            <h2>Enact failed to load</h2>
            <p>
                The rest of Spark should still work as expected.
            </p>
            <p>
                Please refresh the page and try again - if the issue continues, please contact us.
            </p>
            <primevue-button class="enact-load-error-button" @click="showFeedback = true">
                Send feedback
            </primevue-button>
        </div>
    </div>
    <central-modal
        header="Feedback"
        v-model:visible="showFeedback"
    >
        <feedback-overlay @close:overlay="showFeedback = false" />
    </central-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import PrimevueButton from 'primevue/button';
import CentralModal from '@/components/common/CentralModal.vue';
import FeedbackOverlay from '@/components/powerMarkets/overlays/FeedbackOverlay.vue';

const showFeedback = ref<boolean>(false);
</script>

<style scoped lang="scss">
.enact-load-error {
    display: flex;
    min-height: 100%;
    padding: var(--defaultSpacing);

    .enact-load-error-card {
        max-width: 40rem;
        padding: var(--extraLargeSpacing);
        margin: auto;
        background-color: var(--neutral100);
        border: 1px solid var(--neutral300);
        border-radius: var(--borderRadiusOuter);
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        text-align: center;
    }

    p {
        margin: var(--defaultSpacing) 0;
    }
}
</style>
